import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import { GET, PUT } from "../../../API";
import Button from "../../../comps/button";
import Loading from "../../../comps/loading";
import Input from "../../../comps/input";
import { GoSearch } from "react-icons/go";
import { formatDate } from "../../../helpers";
import { BsArrowLeft } from "react-icons/bs";

const AMOUNT = 20;

export default function Archive() {
  const { category } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [dates, setDates] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [processingIds, setProcessingIds] = useState(new Set());

  const getAllDates = async (loadMore = false) => {
    setIsLoading(true);
    try {
      let link;
      if (loadMore) {
        link = `due-dates/${category}/all?amount=${AMOUNT}&page=${Math.ceil(
          dates.length / AMOUNT
        )}&search=${search}`;
      } else {
        link = `due-dates/${category}/all?amount=${AMOUNT}&page=0&search=${search}`;
      }

      console.log("getting data");

      const res = await GET(link);
      const { dates: _dates, total } = await res.json();

      console.log(dates, total);

      // Filter out dates that already have archives created
      // NOTE: Backend should delete archive records after 1 month automatically
      const filteredDates = _dates.filter((d) => !d.archive_created);

      setDates((prv) => {
        if (loadMore) {
          return [...prv, ...filteredDates];
        }
        return filteredDates;
      });
      // Adjust total to account for filtered items
      const archivedCount = _dates.length - filteredDates.length;
      setTotal(total - archivedCount);
    } catch {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    console.log("useEffect");
    getAllDates();
  }, [search]);

  const createArchive = async (idx) => {
    const date = dates[idx];
    const dateId = date.id;

    // Immediately mark as processing and add to processing set
    setProcessingIds(prev => new Set(prev).add(dateId));
    toggleProcess(idx);

    try {
      const res = await PUT(`v1/archive/?date_id=${dateId}`);

      if (res.ok) {
        // Archive creation started - remove from UI immediately
        // The backend will process it in the background
        setDates((prv) => prv.filter((d) => d.id !== dateId));
        setTotal((prv) => prv - 1);
        setProcessingIds(prev => {
          const next = new Set(prev);
          next.delete(dateId);
          return next;
        });
      } else {
        // If failed, revert the processing state
        toggleProcess(idx);
        setProcessingIds(prev => {
          const next = new Set(prev);
          next.delete(dateId);
          return next;
        });
      }
    } catch {
      // On error, revert the processing state
      toggleProcess(idx);
      setProcessingIds(prev => {
        const next = new Set(prev);
        next.delete(dateId);
        return next;
      });
    }
  };

  const toggleProcess = (idx) => {
    setDates((prv) => {
      const _dates = [...prv];
      _dates[idx].archive_in_process = !_dates[idx].archive_in_process;
      return _dates;
    });
  };

  return (
    <div className={styles.Container}>
      <h1>ניהול ארכיון</h1>

      <div className={styles.SearchBar}>
        <Input
          placeholder={"חיפוש תאריכים"}
          icon={<GoSearch />}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className={styles.CardsWrraper}>
        {dates.map((date, i) => (
          <div key={date.id} className={styles.Card}>
            <h2>{date.name}</h2>
            <div className={styles.Dates}>
              <span>{formatDate(date.start_date)}</span>
              <BsArrowLeft />
              <span>{formatDate(date.end_date)}</span>
            </div>
            <div>
              {date.archive_in_process || processingIds.has(date.id) ? (
                <Button disabled>בתהליך...</Button>
              ) : (
                <Button onClick={() => createArchive(i)}>יצירת ארכיון</Button>
              )}
            </div>
          </div>
        ))}
      </div>

      {dates.length < total && (
        <div className={styles.LoadMore}>
          {isLoading ? (
            <Loading />
          ) : (
            <button onClick={() => getAllDates(true)}>טען עוד</button>
          )}
        </div>
      )}
    </div>
  );
}
